module.exports = __webpack_public_path__ + "static/media/mw-stats-logo.97922c1a.png";